import React from 'react';

import { LocateProductSerial } from '@apis/manageInventory/LocateProduct.type';
import { Table as AntTable } from '@atoms/table/Table';
import { capitalize } from '@helpers/stringHelper';

export interface SerialsTableProps {
    locateProductSerials: LocateProductSerial[];
}

const columns = [
    {
        title: 'Serial#',
        dataIndex: 'clientSerial',
        key: 'clientSerial'
    },
    {
        title: 'Status',
        dataIndex: 'conditionCap',
        key: 'conditionCap'
    },
    {
        title: 'Committed',
        dataIndex: 'isCommittedYN',
        key: 'isCommittedYN'
    },
    {
        title: 'Country of Manufacture',
        dataIndex: 'countryOfManufacture',
        key: 'countryOfManufacture'
    },
    {
        title: 'Rev Level',
        dataIndex: 'revisionLevel',
        key: 'revisionLevel'
    },
    {
        title: 'Refurbished',
        dataIndex: 'refurbishedYN',
        key: 'refurbishedYN'
    }
];

export const SerialsTable = ({ locateProductSerials }: SerialsTableProps) => {
    const serials = locateProductSerials.map((serial) => {
        return {
            id: serial.clientSerial,
            refurbishedYN: serial.refurbished ? 'Y' : 'N',
            conditionCap: capitalize(serial.condition),
            isCommittedYN: serial.isCommitted ? 'Y' : 'N',
            ...serial
        };
    });

    return (
        <AntTable
            columns={columns}
            dataSource={serials}
            isLoading={false}
        ></AntTable>
    );
};
